// extracted by mini-css-extract-plugin
export default {"accept-drop":"_3afMC","acceptDrop":"_3afMC","reject-drop":"_17p2U","rejectDrop":"_17p2U"};